// API configuration
export const API_BASE_URL = import.meta.env.VITE_API_URL || '/api'

// Get headers for API requests
export function getHeaders(): Record<string, string> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  }
  
  // In development, add test headers
  if (import.meta.env.DEV) {
    headers['X-Test-User-Email'] = import.meta.env.VITE_TEST_EMAIL || 'test@partner.com'
    headers['X-Partner-Type'] = import.meta.env.VITE_TEST_PARTNER_TYPE || 'Services Partner'
    headers['X-Partner-Tier'] = import.meta.env.VITE_TEST_PARTNER_TIER || 'Standard'
  }
  
  // Cloudflare Access headers will be added automatically by the browser
  // CF-Access-Authenticated-User-Email
  // CF-Access-Jwt-Assertion
  
  return headers
}

// API response types
export interface ApiResponse<T> {
  data?: T
  error?: string
  message?: string
}
